// extracted by mini-css-extract-plugin
export var arrows = "_2z-6";
export var decrementer = "_2z-a";
export var disabled = "_2z-4";
export var error = "_2z-1";
export var hiddenText = "_2z-b";
export var incrementer = "_2z-9";
export var input = "_2z-8";
export var inputWrapper = "_2z-0";
export var leadingIcon = "_2z-c";
export var readonly = "_2z-3";
export var regular = "_2z-7";
export var small = "_2z-5";
export var warning = "_2z-2";